import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  WidthMode,
} from "../services/types/ComponentTypes";

export const screen_158_create_invoice: any[] = [
            {
                "componentType": "screenGroup",
                "title": "Invoice",
                "BindValue": "cont_invoice",
                "childComponents": [
                    {
                        "componentType": "group",
                        "Label": "",
                        "BindValue": "cont_Action",
                        "style": {
                            "direction": "row",
                            "padding": 5,
                            "margin": 0,
                            "marginBottom": 8,
                            "gap": 8
                        },
                        "childComponents": [
                            {
                                "componentType": "button",
                                "Label": "Edit",
                                "BindValue": "btn_Edit",
                                "ActionType": "Edit",
                                "ScreenId": "38",
                                "LockBinding": true,
                                "Enabled": {
                                    "Enable": {
                                        "Json_Attribute": "current_state",
                                        "values": [
                                            "QC Approved"
                                        ]
                                    },
                                    "Mode": [
                                        "View"
                                    ]
                                },
                                "style": {
                                    "backgroundColor": "var(--primary-green)",
                                    "textColor": "#FFFFFF"
                                }
                            },
                            {
                                "componentType": "button",
                                "Label": "lock",
                                "BindValue": "lock",
                                "LockBinding": true,
                                "style": {
                                    "backgroundColor": "var(--primary-green)",
                                    "textColor": "#FFFFFF"
                                }
                            },
                            {
                                "componentType": "button",
                                "Label": "Basic print",
                                "BindValue": "btn_Print",
                                "ActionType": "PDF",
                                "onPressAction": "pdf",
                                "toolTip": "Basic print",
                                "Settings": "Invoice_info_basic",
                                "Enabled": {
                                    "Enable": {
                                        "Json_Attribute": "current_state",
                                        "values": [
                                            "Invoiced",
                                            "Closed"
                                        ]
                                    },
                                    "Mode": [
                                        "View"
                                    ]
                                },
                                "style": {
                                    "backgroundColor": "var(--primary-green)",
                                    "textColor": "#FFFFFF"
                                }
                            },
                            {
                                "componentType": "button",
                                "Label": "Complete print",
                                "BindValue": "btn_Print",
                                "ActionType": "PDF",
                                "onPressAction": "pdf",
                                "toolTip": "Complete print",
                                "Settings": "Invoice_info",
                                "Enabled": {
                                    "Enable": {
                                        "Json_Attribute": "current_state",
                                        "values": [
                                            "Invoiced",
                                            "Closed"
                                        ]
                                    },
                                    "Mode": [
                                        "View"
                                    ]
                                },
                                "style": {
                                    "backgroundColor": "var(--primary-green)",
                                    "textColor": "#FFFFFF"
                                }
                            }
                        ]
                    },
                    {
                        "componentType": "report",
                        "Label": "",
                        "BindValue": "invoice_details",
                        "IncludeLabel": true,
                        "Settings": "invoice_report",
                        "Parent_Field": "parentid"
                    },
                    {
                        "componentType": "form",
                        "Name": "invoice_add",
                        "columnNumber": "m1 t1 w1",
                        "TableName": "service_invoice",
                        "Workflow": "service",
                        "Plugins": [
                            {
                                "type": "api",
                                "module": "all"
                            }
                        ],
                        "DisplayName": "",
                        "style": {
                            "backgroundColor": "#ffffff",
                            "direction": "column",
                            "padding": 10
                        },
                        "LockOnSubmit": true,
                        "DisableSubmit": true,
                        "BindValue": "invoice_add",
                        "SubmitActions": [
                            {
                                "Action": "Navigate",
                                "Navigate": "modulev1/vehicleinsummary"
                            }
                        ],
                        "Fields": [
                            {
                                "componentType": "fieldGroup",
                                "Label": "Invoice Details",
                                "BindValue": "cont_invoice_details",
                                "childComponents": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Invoice No.",
                                        "PlaceHolder": "Will be auto generated...",
                                        "IsMandatory": false,
                                        "BindValue": "txt_inv_no",
                                        "Json_Attribute": "invoice_no",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "AutoPopulate": true,
                                        "AutoPopulate_format": "INV_[******]",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Jobcard No.",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "parentid",
                                        "Json_Attribute": "parent_id",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "LookupName": "invoice_jobcard",
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Customer type",
                                        "PlaceHolder": "",
                                        "IsMandatory": true,
                                        "BindValue": "s_select_customertype",
                                        "Json_Attribute": "customertype",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "LookupName": "customer_type",
                                        "IsVerticalView": true,
                                        "BindParent": {
                                            "parentid": "customertype"
                                        }
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Customer name",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "s_select_insurance_customertype",
                                        "Json_Attribute": "insurance_name",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "LookupName": "insurance_customer",
                                        "IsVerticalView": true,
                                        "BindParent": {
                                            "parentid": "insurance_name"
                                        }
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Invoice date",
                                        "PlaceHolder": "inv_date",
                                        "IsMandatory": true,
                                        "BindValue": "txt_jobdate",
                                        "Json_Attribute": "invoice_date",
                                        "componentType": "datetimeField",
                                        "showInSummary": false,
                                        "IsVerticalView": true,
                                        "DefaultToday": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "LPO No.",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_lpo",
                                        "Json_Attribute": "lpo_number",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Claim No.",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_claim_no",
                                        "Json_Attribute": "claim_no",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Remarks",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_remarks",
                                        "Json_Attribute": "remarks",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "LPO",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "file_lpo",
                                        "Json_Attribute": "lpo_attachment",
                                        "componentType": "files",
                                        "LabelId": "lpo_attachment",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "DO",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "file_do",
                                        "Json_Attribute": "do_attachment",
                                        "componentType": "files",
                                        "LabelId": "do_attachment",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Approval",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "file_approval",
                                        "Json_Attribute": "approval_attachment",
                                        "componentType": "files",
                                        "LabelId": "approval_attachment",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Others",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "file_others",
                                        "Json_Attribute": "Others_attachment",
                                        "componentType": "files",
                                        "LabelId": "others_attachment",
                                        "showInSummary": false,
                                        "IsVerticalView": true
                                    }
                                ]
                            },
                            {
                                "componentType": "subModule",
                                "name": "service_invoice_spareparts",
                                "Label": "Spare parts",
                                "tableName": "service_invoice_spareparts",
                                "lookupName": "invoice_items",
                                "parentField": "parentid",
                                "BindValue": "sub_spareparts",
                                "childControls": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "code",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_code",
                                        "Json_Attribute": "codeid",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "LookupName": "product_itemcode"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Narration",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_narration",
                                        "Json_Attribute": "narration",
                                        "componentType": "textArea",
                                        "showInSummary": false,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Qty",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_qty",
                                        "Json_Attribute": "qty",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "Default_Value": "1",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Rate",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_rate",
                                        "Json_Attribute": "rate",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_amount",
                                        "Json_Attribute": "amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_rate] * [txt_qty]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT%",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_vat",
                                        "Json_Attribute": "vat_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "tax_rates",
                                        "IncludeNotSet": false,
                                        "Default_Value": "5%"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_vat_amt",
                                        "Json_Attribute": "vat_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_net_amt",
                                        "Json_Attribute": "net_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount]+ [txt_vat_amt]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Department",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_department",
                                        "Json_Attribute": "department_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "department"
                                    }
                                ],
                                "FooterControls": [
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_one",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_2",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_3",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_amount",
                                        "Json_Attribute": "spare_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_amount] ",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_6",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "spare_vat_amount",
                                        "Json_Attribute": "spare_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_vat_amt] ",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_net_amount",
                                        "Json_Attribute": "spare_net_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_net_amt] ",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    }
                                ]
                            },
                            {
                                "componentType": "subModule",
                                "name": "service_invoice_labour",
                                "Label": "Labour/Others",
                                "tableName": "service_invoice_labour",
                                "lookupName": "invoice_labour",
                                "parentField": "parentid",
                                "BindValue": "sub_labour",
                                "childControls": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "code",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_code",
                                        "Json_Attribute": "codeid",
                                        "componentType": "searchableDropdown",
                                        "showInSummary": false,
                                        "LookupName": "itemcode",
                                        "Parent_Field": "drp_jobtype"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Narration",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_narration",
                                        "Json_Attribute": "narration",
                                        "componentType": "textArea",
                                        "showInSummary": false,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Qty",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_qty",
                                        "Json_Attribute": "qty",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Rate",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_rate",
                                        "Json_Attribute": "rate",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_amount",
                                        "Json_Attribute": "amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_rate] * [txt_qty]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT%",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_vat",
                                        "Json_Attribute": "vat_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "tax_rates",
                                        "IncludeNotSet": false,
                                        "Default_Value": "5%"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_vat_amt",
                                        "Json_Attribute": "vat_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_net_amt",
                                        "Json_Attribute": "net_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] +  [txt_vat_amt]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Department",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_department",
                                        "Json_Attribute": "department_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "department"
                                    }
                                ],
                                "FooterControls": [
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_one",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_2",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_3",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_amount",
                                        "Json_Attribute": "labour_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_amount]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "labour_vat_amount",
                                        "Json_Attribute": "labour_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_vat_amt] ",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_net_amount",
                                        "Json_Attribute": "labour_net_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_net_amt]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "style": {
                                            "display": "none"
                                        }
                                    }
                                ]
                            },
                            {
                                "componentType": "subModule",
                                "name": "service_invoice_miscellaneous",
                                "Label": "Miscellaneous",
                                "tableName": "service_invoice_miscellaneous",
                                "lookupName": "invoice_miscellaneous",
                                "parentField": "parentid",
                                "BindValue": "sub_miscellaneous",
                                "childControls": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Item type",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_item_type",
                                        "Json_Attribute": "item_type",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "item_type"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Item name",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "item_name",
                                        "Json_Attribute": "item_name",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "inputType": "text"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Qty",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_qty",
                                        "Json_Attribute": "qty",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "Default_Value": "1",
                                        "ControlWidth": "130px",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Rate",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_rate",
                                        "Json_Attribute": "rate",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ControlWidth": "130px",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_amount",
                                        "Json_Attribute": "amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_rate] * [txt_qty]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT%",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_vat",
                                        "Json_Attribute": "vat_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "tax_rates",
                                        "IncludeNotSet": false,
                                        "Default_Value": "5%"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_vat_amt",
                                        "Json_Attribute": "vat_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] * ([drp_vat.taxrate]/100)",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_net_amt",
                                        "Json_Attribute": "net_amt",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[txt_amount] +  [txt_vat_amt]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Department",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "drp_department",
                                        "Json_Attribute": "department_id",
                                        "componentType": "selectDropdown",
                                        "showInSummary": false,
                                        "LookupName": "department"
                                    }
                                ],
                                "FooterControls": [
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_7",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_9",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_amount",
                                        "Json_Attribute": "miscellaneous_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_amount]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "style": {
                                            "display": "none"
                                        }
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "miscellanious_vat_amount",
                                        "Json_Attribute": "miscellanious_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_vat_amt] ",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": false,
                                        "Label": "Net amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_sub_net_amount",
                                        "Json_Attribute": "miscellaneous_net_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[SUM:txt_net_amt]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "componentType": "textField",
                                        "BindValue": "txt_8",
                                        "style": {
                                            "display": "none"
                                        }
                                    }
                                ]
                            },
                            {
                                "componentType": "fieldGroup",
                                "Label": "Summary",
                                "BindValue": "cont_summary",
                                "childComponents": [
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Excess charge",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_excess_charge",
                                        "Json_Attribute": "excess_charge",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Discount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_discount",
                                        "Json_Attribute": "discount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": false,
                                        "Default_Value": "0",
                                        "BindParent": {
                                            "parentid": "discount"
                                        },
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "VAT amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "gross_vat_amount",
                                        "Json_Attribute": "gross_vat_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[(service_invoice_spareparts).spare_vat_amount] + [(service_invoice_labour).labour_vat_amount]+[(service_invoice_miscellaneous).miscellanious_vat_amount]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Gross amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "gross_amount",
                                        "Json_Attribute": "gross_amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[(service_invoice_spareparts).txt_sub_amount] + [(service_invoice_labour).txt_sub_amount]+[(service_invoice_miscellaneous).txt_sub_amount]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    },
                                    {
                                        "IncludeLabel": true,
                                        "Label": "Total amount",
                                        "PlaceHolder": "",
                                        "IsMandatory": false,
                                        "BindValue": "txt_total_amount",
                                        "Json_Attribute": "amount",
                                        "componentType": "textField",
                                        "showInSummary": false,
                                        "IsReadOnly": true,
                                        "ExpressionV2": "[(service_invoice_labour).txt_sub_net_amount] + [(service_invoice_spareparts).txt_sub_net_amount]+[(service_invoice_miscellaneous).txt_sub_net_amount] -[txt_excess_charge]-[txt_discount]",
                                        "Default_Value": "0",
                                        "inputType": "number"
                                    }
                                ]
                            },
                            {
                                "componentType": "group",
                                "Label": "",
                                "BindValue": "cont_Action",
                                "style": {
                                    "direction": "row",
                                    "gap": 8
                                },
                                "childComponents": [
                                    {
                                        "componentType": "button",
                                        "Label": "Submit",
                                        "BindValue": "submit",
                                        "ActionType": "Add",
                                        "ScreenId": "38",
                                        "onPressAction": "save",
                                        "Enabled": {
                                            "Enable": {
                                                "Json_Attribute": "current_state",
                                                "values": [
                                                    "job Card",
                                                    "Invoiced",
                                                    "QC Approved"
                                                ]
                                            },
                                            "Mode": [
                                                "Edit",
                                                "Add"
                                            ]
                                        },
                                        "style": {
                                            "backgroundColor": "var(--primary-green)",
                                            "textColor": "#FFFFFF"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
